import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import {
  SlackIntegrationError,
  SlackIntegrationErrorCode,
} from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import messages from './messages'
import { useUnlinkSlackUserModel } from '../../models/useUnlinkSlackUserModel'

export const useUnlinkSlackUserPresenter = () => {
  const { unlinkUser: unlinkUserMutation, isUnlinking } =
    useUnlinkSlackUserModel()
  const intl = useProcurifyIntl()

  const unlinkUser = async (procurifyUserId: number): Promise<void> => {
    try {
      await unlinkUserMutation({ procurifyUserId })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      const code =
        error instanceof SlackIntegrationError
          ? error.code
          : SlackIntegrationErrorCode.DEFAULT
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          code === SlackIntegrationErrorCode.TOKEN_REVOKED
            ? intl.formatMessage(messages.reconnectErrorMessage)
            : intl.formatMessage(messages.defaultErrorMessage),
      })
      throw error
    }
  }

  return {
    unlinkUser,
    isUnlinking,
  }
}
